import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationBarComponent } from './navigation-bar.component';
import { NavigationBarItemComponent } from './navigation-bar-item/navigation-bar-item.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [NavigationBarComponent, NavigationBarItemComponent],
  exports: [NavigationBarComponent, NavigationBarItemComponent]
})
export class NavigationBarModule { }
